import { ShoppingCartOutlined, KeyboardArrowRight } from '@mui/icons-material';
import { Box, Hidden, Stack, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { API } from '../utils/Api';
import axios from 'axios';
import { setData } from '../store/Cart/cartSlice';
import { useEffect, useState } from 'react';

function FloatingCart() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartData = useSelector(state => state.cart.data);
  const orderType = localStorage.getItem("selectedOrderType");
  const [outletData, setOutletData] = useState(JSON.parse(localStorage.getItem('selectedStoreData')));
  const data = useSelector(state => state?.cart?.data);

  useEffect(() => {
    if (!outletData?._id || !token) return;
    setOutletData(JSON.parse(localStorage.getItem('selectedStoreData')));
    const fetchCartData = async () => {
      try {
        const response = await axios.get(`${API.BASE_URL_2}cart/userCart/new/${outletData._id}/${orderType}?source=WEBSITE`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        dispatch(setData(response?.data));
      } catch (error) {
        dispatch(setData([]));
      }
    };
    fetchCartData();
  }, [dispatch]);

  const totalQuantity = data?.data?.cartItems?.reduce((acc, item) => acc + item.quantity, 0) || 0;

  return (
    <Hidden mdUp>
      {totalQuantity > 0 && (
        <Box
            className="floatingCart"
            onClick={() => navigate('/cartScreen')}
            // sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 1 }}
          >
            <Box sx={{ pl: 4 }}>
              <Typography>
                {totalQuantity} {totalQuantity === 1 ? 'Item' : 'Items'}
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent={'space-around'}
              sx={{
                backgroundColor: '#FFFFFF',
                borderRadius: '40px',
                py: '5px',
                px: 2,
              }}
            >
              <Box display="flex" flexDirection="row" alignItems="center">
                <ShoppingCartOutlined sx={{ fontSize: 18, color: '#09A5F7', pr: 0.5 }} />
                <Typography color="#0E4961">Cart</Typography>
              </Box>
              <KeyboardArrowRight sx={{ color: '#0E4961' }} />
            </Box>
          </Box>
      )}
    </Hidden>
  )
}

export default FloatingCart;
